module.exports = __webpack_public_path__ + "img/selected4-min.a3995b29.png";